/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import { motion } from "framer-motion";
import { Spin } from "antd";
import { css } from "@emotion/react";
import { useThemeTokens } from "../../hooks/useThemeTokens";
import { getGradient } from "../../utils/themeUtils";
import { splashVariants } from "../../utils/animations";
import { AppContext } from "../../App";
import Logo from "../home/Logo";

/**
 * Splash Screen profesional con diseño minimalista futurista.
 * Usa tokens configurables para todos los colores.
 * Previene el flash de login mostrándose durante la validación de autenticación.
 */
const SplashScreen = () => {
  const tokens = useThemeTokens();
  const { state } = useContext(AppContext);
  const isDark = state?.algorithm === "dark";

  // Estilos usando tokens configurables
  const splashStyles = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${isDark ? tokens.colorBgLayout : tokens.colorBgContainer};
    z-index: 9999;
    overflow: hidden;

    /* Efecto de gradiente sutil usando tokens */
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${getGradient(tokens, "135deg")};
      opacity: ${isDark ? 0.1 : 0.05};
      pointer-events: none;
    }
  `;

  const logoContainerStyles = css`
    position: relative;
    z-index: 1;
    margin-bottom: ${tokens.marginLG * 2}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${tokens.marginLG}px;
  `;

  const logoStyles = css`
    width: 120px;
    height: 120px;
    filter: ${isDark ? "brightness(1.1)" : "brightness(1)"};
    transition: transform 0.3s ease;
  `;

  const spinnerContainerStyles = css`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${tokens.margin}px;
  `;

  const textStyles = css`
    color: ${tokens.colorText};
    font-size: ${tokens.fontSize}px;
    font-weight: 400;
    letter-spacing: 0.5px;
    opacity: 0.7;
  `;

  return (
    <motion.div
      css={splashStyles}
      variants={splashVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div css={logoContainerStyles}>
        <motion.div
          css={logoStyles}
          animate={{
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <Logo />
        </motion.div>
      </div>

      <div css={spinnerContainerStyles}>
        <Spin
          size="large"
          style={{
            color: tokens.colorPrimary,
          }}
        />
        <div css={textStyles}>Cargando...</div>
      </div>
    </motion.div>
  );
};

export default SplashScreen;

